import { Card, Col, Divider, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";

import { InputNumber, Select, Switch, TimePicker } from "components/form";
import { useTranslation } from "react-i18next";
import schema from "../../../features/company/schemas/companyOTCondSchema";

import styles from "../styles/CompanyProfile.module.css";
import { Footer } from "antd/es/layout/layout";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";

function CompanyOverTimeEdit({
  isLoading = false,
  initialValues = {},
  otReqConditionOptions = [],
  breakPeriodTypeOptions = [],
  selectedBreakPeriodType = {},
  selectedOtReqCondition = {},
  handleBreakPeriodTypeChange = () => { },
  handleOtReqConditionChange = () => { },
  onSubmit = () => { },
  onCancel = () => { },
}) {
  const { t, i18n } = useTranslation();

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...initialValues }}
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, setFieldValue, setTouched }) => {
        return (
          <Form>
            <Space className={styles.container} size={24} direction="vertical">
              <Card style={{ border: "solid 1px #EAECF0" }} >
                <b className={styles.infoTopic}>
                  {t("overtime_condition.label.withdrawal_request")}
                </b>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <InputNumber
                      required
                      name="minimumRequired"
                      label={
                        t("overtime_condition.label.minimum_period_required min")
                      }
                      size="large"
                      max={480}
                      min={0}
                      // formatter={() => { }}
                      precision={0}
                      controls={false}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <InputNumber
                      name="docLimitPerDay"
                      label={t(
                        "overtime_condition.label.document_limit_per_day_limit"
                      )}
                      size="large"
                      stringMode
                      formatter={(value) => { return get2DecimalPointsWithCommas(value, 0, true) }}
                      // min={0}
                      // value={0}
                      controls={false}
                      textAlign="left"
                    />
                  </Col>
                  <Col span={12}>
                    <Select
                      required
                      name="otReqCondition"
                      label={t(
                        "overtime_condition.label.overtime_request_condition"
                      )}
                      size="large"
                      options={otReqConditionOptions}
                      onChange={handleOtReqConditionChange}
                      placeholder={t('please-select-0')}
                    />
                  </Col>
                  {selectedOtReqCondition === "Must withdraw in advance" ? (<Col span={12}>
                    <InputNumber
                      name="advanceAtLeast"
                      label={t("overtime_condition.label.advance_atLeast")}
                      formatter={(value) => { return get2DecimalPointsWithCommas(value, 0) }}
                      size="large"
                      stringMode
                      min={0}
                      value={0}
                      controls={false}
                      textAlign="left"
                    />
                  </Col>
                  ) : (
                    <Col span={0}></Col>
                  )}
                  {selectedOtReqCondition === "To be withdrawn retrospectively" ? (<Col span={12}>
                    <InputNumber
                      name="advanceLessThan"
                      label={t("overtime_condition.label.advance_less_than")}
                      size="large"
                      formatter={(value) => { return get2DecimalPointsWithCommas(value, 0) }}
                      stringMode
                      min={0}
                      value={0}
                      controls={false}
                      textAlign="left"
                    />
                  </Col>
                  ) : (
                    <Col span={0}></Col>
                  )}
                  <Col span={24}>
                    <Switch
                      name="permanentEmployeesOnly"
                      label={t(
                        "overtime_condition.label.permanent_employees_only"
                      )}
                    />
                  </Col>
                </Row>
              </Card>
              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("overtime_condition.label.condition")}
                </b>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <Select
                      required
                      name="breakPeriodType"
                      label={t("overtime_condition.label.break_period_type")}
                      size="large"
                      options={breakPeriodTypeOptions}
                      onChange={handleBreakPeriodTypeChange}
                      placeholder={t('please-select-0')}
                    />
                  </Col>
                  <Col span={12} />
                  {selectedBreakPeriodType === "Broken once" ? (<>
                    <Col span={12}>
                      <InputNumber
                        required
                        name="breakPeriod"
                        label={t("overtime_condition.label.break_period min")}
                        size="large"
                        // max={60}
                        min={0}
                        // formatter={() => { }}
                        precision={0}
                        // onChange={
                        //   console.log(values?.breakPeriod)
                        // }
                        controls={false}
                        textAlign="left"
                      />
                    </Col>
                    <Col span={12}>
                      <TimePicker
                        required
                        name="workingPeriodBeforeStartBreakDeduction"
                        label={t("overtime_condition.label.working_period_before_start_break_deduction Hour")}
                        size="large"
                        format="HH:mm"
                      // onChange={
                      //   console.log(values.workingPeriodBeforeStartBreakDeduction)
                      // }
                      />
                    </Col>
                  </>
                  ) : (
                    <Col span={0}></Col>
                  )}
                  {selectedBreakPeriodType === "Continuously broken" ? (<>
                    <Col span={12}>
                      <InputNumber
                        required
                        name="breakPeriod"
                        label={t("overtime_condition.label.break_period min")}
                        size="large"
                        // max={60}
                        min={0}

                        // formatter={() => { }}
                        precision={0}
                        controls={false}
                        textAlign="left"
                      />
                    </Col>
                    <Col span={12}>
                      <TimePicker
                        required
                        name="breakDeductionEveryWorkingPeriod"
                        label={t("overtime_condition.label.break_deduction_every_working_period")}
                        size="large"
                        format="HH:mm"
                      />
                    </Col>
                  </>
                  ) : (
                    <Col span={0}></Col>
                  )}
                  {/* <Col span={24}>
                    <Switch
                      name="otRounding"
                      label={t("overtime_condition.label.overtime_rounding")}
                    />
                  </Col> */}
                  {values.otRounding ? (
                    <Col span={12}>
                      <InputNumber
                        required
                        name="calculateOtEvery"
                        label={t(
                          "overtime_condition.label.calculate_overtime_in_every_min"
                        )}
                        size="large"
                        stringMode
                        min={0}
                        value={0}
                        controls={false}
                        formatter={(value) => { return get2DecimalPointsWithCommas(value, 0) }}
                        textAlign="left"
                      />
                    </Col>
                  ) : (
                    <Col span={0}></Col>
                  )}
                  {/* { values?.limitovertimePerWeek} */}
                  <Col span={24}>
                    <Switch
                      name="limitovertimePerWeek"
                      label={t(
                        "overtime_condition.label.limir overtime hours per weerk"
                      )}
                    />
                  </Col>
                  {
                    values?.limitovertimePerWeek ?
                      <Col span={12}>
                        <InputNumber
                          required
                          name="maximunnumberofhoursperweek"
                          label={t("overtime_condition.label.maximun number of hours per week min")}
                          size="large"
                          // max={}
                          min={0}
                          // formatter={() => { }}
                          precision={0}
                          controls={false}
                          textAlign="left"
                        />
                      </Col>
                      : null
                  }
                  <Col span={24}>
                    <Switch
                      name="calculateOtHolidayByShift"
                      label={t(
                        "overtime_condition.label.calculate_overtime_holiday"
                      )}
                    />
                  </Col>
                  <Col span={24}>
                    <Switch
                      name="deductBreakHolidayShift"
                      label={t("overtime_condition.label.deduct_break_holiday")}
                    />
                  </Col>
                  <Col span={24}>
                    <Switch
                      name="allowOtUnCompleteDays"
                      label={t(
                        "overtime_condition.label.allow_overtime_uncomplete_workdays"
                      )}
                    />
                  </Col>
                  <Col span={24}>
                    <Switch
                      name="payOtFlexShifts"
                      label={t(
                        "overtime_condition.label.pay_overtime_fully_on_flexible_shifts"
                      )}
                    />
                  </Col>
                </Row>
              </Card>

              <Card style={{ border: "solid 1px #EAECF0" }}>
                <b className={styles.infoTopic}>
                  {t("overtime_condition.label.condition_ot_request")}
                </b>
                <Divider />
                <Row gutter={[24, 16]}>
                  <Col span={24}>
                    <Switch
                      name="employeeRequest"
                      label={t(
                        "overtime_condition.label.not_allow_emp_request_ot"
                      )}
                    />
                  </Col>
                  <Col span={24}>
                    <Switch
                      name="supervisorRequest"
                      label={t(
                        "overtime_condition.label.allow_sup_request_ot"
                      )}
                    />
                  </Col>
                </Row>
              </Card>
            </Space>
            <Footer style={{
              zIndex: 999,
              bottom: 1,
              position: 'sticky',
              backgroundColor: 'white',
              // backdropFilter: 'blur(90px)',
              // borderRadius: '10rem',
              height: "fit-content",
              // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              padding: '10px 50px',
              // display: 'flex',
              // justifyContent: 'end',
              // alignItems: 'center',
            }}>
              <Row justify="end" >
                <Space>
                  <Button type="default" onClick={() => {
                    onCancel();
                  }}
                    style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                  >
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                    {t("common.submit").toUpperCase()}
                  </Button>
                </Space>
              </Row>
            </Footer>
          </Form>
        );
      }}
    </Formik >
  );
}

export default CompanyOverTimeEdit;